// import libraries
import React from "react";

// import custom components
import Header from "../../components/Header";
import MainContent from "../../components/MyFlights/MainContent";
import Footer from "../../components/Footer";

const MyFlights = () => (
  <>
    <Header />
    <MainContent />
    <Footer />
  </>
);

export default MyFlights;
